import HorizontalProductCard from './Horizontal/HorizontalProductCard'
import VerticalProductCard from './Vertical/VerticalProductCard'

import React from 'react'

const EnhancedProductCard = ({ product, page, imageLoadingProps = null }) => {
  if (!page) {
    console.error(
      "The page prop is required for the EnhancedProductCard component. This is needed for unique GA events. Examples are 'prp', 'cart', etc.",
    )
    return false
  }

  return <HorizontalProductCard product={product} page={page} imageLoadingProps={imageLoadingProps} />
}

EnhancedProductCard.Horizontal = HorizontalProductCard
EnhancedProductCard.Vertical = VerticalProductCard

export default EnhancedProductCard
